import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Bell, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import UpcomingEvents from "@/components/UpcomingEvents";
import MemberAttendanceCard from "@/components/MemberAttendanceCard";
import { StatBadgeRow } from "@/components/MemberStatBadges";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/components/PageHeader";
import { useFeatureFlags } from "@/lib/featureFlags";
import api from "@/lib/api";
import { shortenNos } from "@/lib/caseNo";

export default function ParentStudentDashboard() {
  const { schedule: scheduleOn, merit_tracking: meritOn, lettering: letteringOn } = useFeatureFlags();
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [th, setTh] = useState(null);

  useEffect(() => {
    api.get(`/parent/students/${id}/dashboard`).then(({ data }) => setD(data)).catch(() => {});
    api.get(`/parent/students/${id}/thespian`).then(({ data }) => setTh(data)).catch(() => setTh(null));
  }, [id]);
  const { user } = useAuth();

  return (
    <div data-testid="parent-student-dashboard">
      <StatBadgeRow d={d} th={th} meritOn={meritOn} letteringOn={letteringOn} thespianOn
        links={{ merits: "../record", lettering: "../record", thespian: "../record" }}
        seenKey={user?.id && `${user.id}_${id}`} tp="parent-" />

      <MemberAttendanceCard endpoint={`/parent/students/${id}/attendance`} to={`/parent/students/${id}/schedule?tab=attendance`} />
      {scheduleOn && <UpcomingEvents endpoint={`/parent/students/${id}/schedule`} to="../schedule" />}

      {d?.recent_notifications?.length > 0 && (
      <Link to="../notifications" className="block">
        <Card className="mt-6 p-6 border-slate-200 shadow-sm transition-shadow hover:shadow-md" data-testid="parent-recent-notifications">
          <div className="mb-4 flex items-center gap-2 group">
            <Bell className="h-5 w-5 text-slate-400" />
            <h3 className="font-heading text-lg font-semibold text-slate-800">Notifications</h3>
            <ChevronRight className="h-4 w-4 text-slate-400 transition-transform group-hover:translate-x-0.5" />
          </div>
          <div className="divide-y divide-slate-100">
            {d.recent_notifications.map((n) => (
              <div key={n.id} className="flex items-start gap-3 py-3">
                <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${n.read ? "bg-slate-300" : "bg-sky-500"}`} />
                <div>
                  <p className="text-sm font-semibold text-slate-800">{n.title}</p>
                  <p className="text-sm text-slate-500">{shortenNos(n.message)}</p>
                  <p className="text-xs text-slate-400">{fmtDate(n.created_at)}</p>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </Link>
      )}
    </div>
  );
}
